import { ManageNotifications } from "pages";
import adminRouteMap from "routeControl/adminRouteMap";

/**
 * Generates an array of route objects for managing CMS in the admin section.
 * @returns {Array} An array containing the route object for managing CMS.
 */
export default function route() {
  return [
    {
      path: adminRouteMap.MANAGELINK.path,  // URL path for managing CMS
      private: true,  // Requires authentication to access
      name: "Notifications",  // Display name for the route
      key: adminRouteMap.MANAGELINK.path,  // Unique key for the route
      belongsToSidebar: true,  // Appears in the admin sidebar
      icon: adminRouteMap.MANAGELINK.icon,  // Icon associated with managing CMS
      element: <ManageNotifications />
    },
  ];
}
